export { LoginPage, type LoginFormData } from '../../console/pages/LoginPage/LoginPage';
export { SystemAboutPage } from '../../console/pages/SystemAboutPage/SystemAboutPage';
// export { DevDebugPage } from '../../demo/pages/DevDebugPage';
export { AppearanceSettingPage } from '../../console/pages/AppearanceSettingPage/AppearanceSettingPage';
